/**
 * Month-over-month change, classified.
 *
 * Spec 22.2 asks for deterministic insight, not AI: "spending is down sharply" is a rule
 * about two numbers. The numbers themselves (the delta) come from SQL; what happens here is
 * turning a ratio into a word the screen can use.
 */
const FLAT_PCT = 2;
const SLIGHT_PCT = 10;
const NOTABLE_PCT = 25;
/**
 * Compares a period against its baseline.
 *
 * `delta` and `baseline` are the figures SQL produced. A zero baseline has no meaningful
 * percentage — spending appearing where there was none before is "up", not "up ∞%" — so
 * `pct` is null and the intensity falls back to whether anything happened at all.
 */
export function classifyChange(input) {
    const { delta, baseline } = input;
    if (delta === 0)
        return { direction: 'flat', intensity: 'flat', pct: 0 };
    const direction = delta > 0 ? 'up' : 'down';
    if (baseline <= 0)
        return { direction, intensity: 'strong', pct: null };
    const pct = Math.round((Math.abs(delta) / baseline) * 1000) / 10;
    const intensity = pct < FLAT_PCT
        ? 'flat'
        : pct < SLIGHT_PCT
            ? 'slight'
            : pct < NOTABLE_PCT
                ? 'notable'
                : 'strong';
    // A change too small to matter reads as flat whichever way it went.
    return { direction: intensity === 'flat' ? 'flat' : direction, intensity, pct };
}
//# sourceMappingURL=change.js.map